import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutRearrangeStops extends Layout {
    labelDragStopsToRearrangeThem: Label;
    sourceStop: DataSource;
    tableStop: Table;
}
